/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrcode1Inputs */

const en_qrcode1 = /** @type {(inputs: Qrcode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR code`)
};

const de_qrcode1 = /** @type {(inputs: Qrcode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code`)
};

/**
* | output |
* | --- |
* | "QR code" |
*
* @param {Qrcode1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrcode1 = /** @type {((inputs?: Qrcode1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrcode1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrcode1(inputs)
	return de_qrcode1(inputs)
});
export { qrcode1 as "qrCode" }